module.exports = __webpack_public_path__ + "static/media/nft.9fb4fd53.png";